import React from "react";
import { Navigate } from "react-router-dom";

const isAuthenticated = () => {
  // Check if a valid token exists in localStorage
  return !!localStorage.getItem("token") || !!sessionStorage.getItem("token");
};

const AuthRoute = ({ element: Component, ...rest }) => {
  return isAuthenticated() ? Component : <Navigate to="/login" />;
};

export default AuthRoute;
